export default "__VITE_ASSET__BgzQMWHG__"